// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from "react-intl";

// assets
import Medicines from "../assets/icons/medicine-02.svg";

const icons = {
  medicaments: () => <img src={Medicines} alt="expert icon" />,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const medicaments = {
  id: "medicaments",
  title: <FormattedMessage id="medicaments" />,
  type: "group",
  url: "/medicaments",
  icon: icons.medicaments,
};

export default medicaments;
